module.exports = __webpack_public_path__ + "static/img/1.39a96f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/1.png
// module id = 9gPj
// module chunks = 0